import { render, staticRenderFns } from "./NavPanelPreloader.vue?vue&type=template&id=707cea36&scoped=true&"
var script = {}
import style0 from "./NavPanelPreloader.vue?vue&type=style&index=0&id=707cea36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707cea36",
  null
  
)

export default component.exports